import { render, staticRenderFns } from "./OppregNewQuestionnaire.vue?vue&type=template&id=a527be52&scoped=true&"
import script from "./OppregNewQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./OppregNewQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./OppregNewQuestionnaire.vue?vue&type=style&index=0&id=a527be52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a527be52",
  null
  
)

export default component.exports